import { NotificationsModel } from "app/models";
import { useHistory } from "react-router-dom";
import { markRead } from "app/actions/Notification";
import { useActions } from "app/utils/hooks";

export const useNotificationsListModel = () => {
  const history = useHistory();
  const notificationAction = useActions({ markRead });

  const route = (path: string) => {
    history.push(path);
  };

  const onNotificationClick = (notification: NotificationsModel) => {
    if (notification?.id && !notification.read) {
      notificationAction.markRead(notification.id);
    }

    if (notification?.targetUrl) {
      return route(notification.targetUrl);
    }
  };

  return {
    onNotificationClick,
  };
};
